import React from 'react';

import { RolesDashboard } from '../../components/RolesDashboard';

function Dashboard() {
  return <RolesDashboard />;
}

export default Dashboard;
